import { useEffect, useState } from "react";
import { Badge, Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import print from "../../../Enums/Print";
import Pagination from "../Pagination/Pagination";
import { ExportExcel } from "../../../Enums/Export";
import ReportsService from "../../../../services/ReportsService";
import Select from "react-select";

const MatchesReports = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [params, setParams] = useState({});
	const lang = useSelector((state) => state.auth?.lang);
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);
	const options = [
		{ label: Translate[lang].active, value: "active" },
		{ label: Translate[lang].deactive, value: "inactive" },
	];
	const typesOptions = [
		{ label: Translate[lang].public, value: "public" },
		{ label: Translate[lang].private, value: "private" },
		{ label: Translate[lang].tournament, value: "tournament" },
	];
	const optionsOptions = [
		{ label: Translate[lang].beginner, value: "beginner" },
		{ label: Translate[lang].intermediate, value: "intermediate" },
		{ label: Translate[lang].advanced, value: "advanced" },
	];
	const matchesTypeOneOptions = [
		{ label: Translate[lang].double, value: "double" },
		{ label: Translate[lang].single, value: "single" },
	];
	const tournamentsOptions = [
		{ label: Translate[lang].competition, value: "competition" },
		{ label: Translate[lang].americano, value: "americano" },
	];
	const [paramsData, setParamsData] = useState({
		status: "",
		level: "",
		match_type: "",
		date: "",
		main_type: typesOptions[0],
	});

	useEffect(() => {
		let paramsUpdate = {};
		if (!!paramsData?.status)
			paramsUpdate["status"] = paramsData?.status?.value;
		if (!!paramsData?.level) paramsUpdate["level"] = paramsData?.level?.value;
		if (!!paramsData?.match_type)
			paramsUpdate["type"] = paramsData?.match_type?.value;
		if (!!paramsData?.date) paramsUpdate["date"] = paramsData?.date;
		setParams(paramsUpdate);
		setShouldUpdate((prev) => !prev);
	}, [paramsData]);

	const printPage = () => {
		let headRow =
			paramsData?.main_type?.value === "tournament"
				? [
						Translate[lang].court,
						Translate[lang].date,
						Translate[lang].time,
						Translate[lang].tournament_name,
						Translate[lang].number_of_teams,
						Translate[lang].tournament_type,
						Translate[lang].match_type,
						Translate[lang].level,
						Translate[lang].price,
						Translate[lang].note,
						Translate[lang].court_booking,
						Translate[lang].status,
				  ]
				: [
						Translate[lang].court,
						Translate[lang].date,
						Translate[lang].time,
						Translate[lang].type,
						Translate[lang].match_type,
						Translate[lang].level,
						Translate[lang].price,
						Translate[lang].note,
						Translate[lang].court_booking,
						Translate[lang].status,
				  ];
		let dataInfo = data?.map((res) => {
			let info = {};
			if (paramsData?.main_type?.value === "tournament") {
				info = {
					name: res?.court[`name_${lang}`],
					date: res.date?.split("T")[0] || "-",
					time: res.time || "-",
					tournament_name: res?.tournament_name,
					number_of_team: res?.number_of_team,
					tournament_type: Translate[lang][res?.tournament_type],
					kind: Translate[lang][res?.kind] || "-",
					level: Translate[lang][res?.level],
					price: res?.court_price?.toFixed(3) || "-",
					note: res?.note || "-",
					is_court_booked: res?.is_court_booked
						? Translate[lang]["yes"]
						: Translate[lang]["no"],
					status: res?.status,
				};
			} else {
				info = {
					name: res?.court[`name_${lang}`],
					data: res.date?.split("T")[0] || "-",
					time: res.time || "-",
					type: Translate[lang][res?.type],
					kind: Translate[lang][res?.kind],
					level: Translate[lang][res?.level],
					price: res?.court_price?.toFixed(3) || "-",
					note: res?.note || "-",
					is_court_booked: res?.is_court_booked ? "yes" : "no",
					status: res?.status,
				};
			}
			return info;
		});
		print(`${paramsData?.main_type?.value} Matches`, headRow, lang, dataInfo);
	};

	return (
		<>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].matches_reports}
				</span>
				<div className="d-flex gap-8">
					<Button
						variant="outline-primary"
						onClick={() => ExportExcel(data, "matches-reports")}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								fontSize: "18px",
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div className="row w-100 m-auto">
							<div className="col-md-3 col-6 mb-3">
								<label>{Translate[lang].type}</label>
								<Select
									options={typesOptions}
									value={paramsData?.main_type}
									onChange={(e) => {
										setParamsData((prev) => ({
											...prev,
											main_type: e,
											match_type: "",
										}));
									}}
								/>
							</div>
							<div className="col-md-3 col-6 mb-3">
								<label>{Translate[lang].match_type}</label>
								<Select
									options={
										paramsData?.main_type?.value === "tournament"
											? tournamentsOptions
											: matchesTypeOneOptions
									}
									value={paramsData?.match_type}
									onChange={(e) => {
										setParamsData((prev) => ({ ...prev, match_type: e }));
									}}
								/>
							</div>
							<div className="col-md-3 col-6 mb-3">
								<label>{Translate[lang].status}</label>
								<Select
									options={options}
									value={paramsData?.status}
									onChange={(e) =>
										setParamsData((prev) => ({ ...prev, status: e }))
									}
								/>
							</div>
							<div className="col-md-3 col-6 mb-3">
								<label className="d-block">{Translate[lang].date}</label>
								<input
									type="date"
									name={"date"}
									value={paramsData?.date}
									placeholder={Translate[lang].date}
									style={{
										height: "43px",
										padding: "0 10px",
										borderRadius: "10px",
										border: "1px solid hsl(0, 0%, 80%)",
										width: "100%",
									}}
									onChange={(e) =>
										setParamsData((prev) => ({
											...prev,
											date: e.target?.value,
										}))
									}
								/>
							</div>
							<div className="col-md-3 col-6 mb-3">
								<label>{Translate[lang].level}</label>
								<Select
									options={optionsOptions}
									value={paramsData?.level}
									onChange={(e) =>
										setParamsData((prev) => ({ ...prev, level: e }))
									}
								/>
							</div>
							<div className={"col-md-2 col-6"}>
								<div className="d-flex h-100 gap-8 align-items-end">
									{(!!paramsData?.status ||
										!!paramsData?.level ||
										!!paramsData?.match_type ||
										!!paramsData?.date) && (
										<Button
											variant="outline-danger"
											className="w-100"
											onClick={() => {
												setParamsData((prev) => ({
													...prev,
													status: "",
													level: "",
													match_type: "",
													date: "",
												}));
												setShouldUpdate((prev) => !prev);
											}}>
											{Translate[lang].clear_filter}
										</Button>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-4">
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].court}</strong>
									</th>
									<th>
										<strong>{Translate[lang].date}</strong>
									</th>
									<th>
										<strong>{Translate[lang].time}</strong>
									</th>
									{paramsData?.main_type?.value === "tournament" && (
										<th>
											<strong>{Translate[lang].tournament_name}</strong>
										</th>
									)}
									{paramsData?.main_type?.value === "tournament" && (
										<th>
											<strong>{Translate[lang].number_of_teams}</strong>
										</th>
									)}
									<th>
										<strong>
											{paramsData?.main_type?.value === "tournament"
												? Translate[lang].tournament_type
												: Translate[lang].type}
										</strong>
									</th>
									<th>
										<strong>{Translate[lang].match_type}</strong>
									</th>
									<th>
										<strong>{Translate[lang].level}</strong>
									</th>
									<th>
										<strong>{Translate[lang].price}</strong>
									</th>
									<th>
										<strong>{Translate[lang].note}</strong>
									</th>
									<th>
										<strong>{Translate[lang].court_booking}</strong>
									</th>
									<th>
										<strong>{Translate[lang].status}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<tr key={index} className="text-center">
											<td className="text-wrap-mode">
												{!!item?.court?.name_en
													? item?.court[`name_${lang}`]
													: "-"}
											</td>
											<td className="text-wrap-mode">
												{item?.date?.split("T")[0] || "-"}
											</td>
											<td className="text-wrap-mode">{item?.time || "-"}</td>
											{paramsData?.main_type?.value === "tournament" && (
												<td className="text-wrap-mode text-capitalize">
													{item?.tournament_name}
												</td>
											)}
											{paramsData?.main_type?.value === "tournament" && (
												<td className="text-wrap-mode text-capitalize">
													{item?.number_of_team}
												</td>
											)}
											<td className="text-wrap-mode text-capitalize">
												{Translate[lang][
													paramsData?.main_type?.value === "tournament"
														? item?.tournament_type
														: item?.type
												] || "-"}
											</td>
											<td className="text-wrap-mode text-capitalize">
												{Translate[lang][item?.kind] || "-"}
											</td>
											<td className="text-wrap-mode text-capitalize">
												{Translate[lang][item?.level] || "-"}
											</td>
											<td className="text-wrap-mode">
												{item?.court_price?.toFixed(3) || "-"}{" "}
												{!!item?.court_price ? Translate[lang].kwd : ""}
											</td>
											<td className="text-wrap-mode">{item?.note || "-"}</td>
											<td className="text-wrap-mode">
												{item?.is_court_booked
													? Translate[lang].yes
													: Translate[lang].no || "-"}
											</td>
											<td>
												<Badge
													className="text-capitalize"
													variant={`${
														item?.status === "active" ? "success" : "danger"
													} light`}>
													{
														Translate[lang][
															item?.status === "active" ? "active" : "deactive"
														]
													}
												</Badge>
											</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						type={paramsData?.main_type?.value}
						param={params}
					/>
				</div>
			</div>
		</>
	);
};

export default MatchesReports;
